"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectorPrefix = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var adhere_ui_configprovider_1 = __importDefault(require("@baifendian/adhere-ui-configprovider"));
var Auto_1 = __importDefault(require("./Auto"));
var BackLayout_1 = __importDefault(require("./BackLayout"));
var Context_1 = require("./Context");
var Fixed_1 = __importDefault(require("./Fixed"));
var HorizontalFlexLayout_1 = __importDefault(require("./HorizontalFlexLayout"));
var ScrollLayout_1 = __importStar(require("./ScrollLayout"));
var TRBLC = __importStar(require("./TRBLC"));
var ToolBarLayout_1 = __importDefault(require("./ToolBarLayout"));
var Util_1 = require("./Util");
var VerticalFlexLayout_1 = __importDefault(require("./VerticalFlexLayout"));
exports.selectorPrefix = 'adhere-ui-flex-layout';
/**
 * InternalFlexLayout
 * @param {FlexLayoutProps} props
 * @param ref
 * @constructor
 */
var InternalFlexLayout = (0, react_1.memo)((0, react_1.forwardRef)(function (props, ref) {
  var className = props.className,
    style = props.style,
    direction = props.direction,
    gutter = props.gutter,
    children = props.children,
    attrs = __rest(props, ["className", "style", "direction", "gutter", "children"]);
  var media = (0, react_1.useContext)(adhere_ui_configprovider_1.default.Context).media;
  var targetDirection = (0, react_1.useMemo)(function () {
    return direction !== null && direction !== void 0 ? direction : 'vertical';
  }, [direction]);
  /**
   * getVerticalGridStyle
   */
  var getVerticalGridStyle = (0, react_1.useCallback)(function () {
    return {};
  }, []);
  /**
   * getHorizontalGridStyle
   */
  var getHorizontalGridStyle = (0, react_1.useCallback)(function () {
    var rowGapOrigin = 0;
    var columnGapOrigin = 0;
    if (Array.isArray(gutter)) {
      if (gutter.length === 1) {
        rowGapOrigin = gutter[0];
        columnGapOrigin = gutter[0];
      } else if (gutter.length === 2) {
        rowGapOrigin = gutter[0];
        columnGapOrigin = gutter[1];
      }
    } else {
      rowGapOrigin = gutter;
      columnGapOrigin = gutter;
    }
    var columnGapOriginValue = (0, Util_1.getValueWithUnit)(columnGapOrigin / 2, media);
    return {
      rowGap: (0, Util_1.getValueWithUnit)(rowGapOrigin, media),
      marginLeft: "-".concat(columnGapOriginValue),
      marginRight: "-".concat(columnGapOriginValue)
    };
  }, [gutter, media]);
  /**
   * getGridStyle
   */
  var getGridStyle = (0, react_1.useCallback)(function () {
    var _a;
    var map = new Map([['horizontal', getHorizontalGridStyle], ['vertical', getVerticalGridStyle]]);
    return (_a = map.get(targetDirection)) === null || _a === void 0 ? void 0 : _a();
  }, [targetDirection, getHorizontalGridStyle, getVerticalGridStyle]);
  // class
  var classList = (0, react_1.useMemo)(function () {
    return (0, classnames_1.default)(exports.selectorPrefix, className, "".concat(exports.selectorPrefix, "-").concat(targetDirection));
  }, [className, targetDirection]);
  // style
  var styleList = (0, react_1.useMemo)(function () {
    var defaultStyle = style !== null && style !== void 0 ? style : {};
    // 栅格的style
    var gridStyle = 'gutter' in props ? getGridStyle() : {};
    return __assign(__assign({}, defaultStyle), gridStyle);
  }, [style, gutter, getGridStyle]);
  return react_1.default.createElement(Context_1.FlexContext.Provider, {
    value: {
      gutter: gutter,
      direction: targetDirection,
      children: children
    }
  }, react_1.default.createElement("div", __assign({
    ref: ref
  }, attrs, {
    className: classList,
    style: styleList
  }), children));
}));
var FlexLayout = InternalFlexLayout;
FlexLayout.displayName = 'FlexLayout';
FlexLayout.selectorPrefix = exports.selectorPrefix;
FlexLayout.Context = Context_1.FlexContext;
FlexLayout.Fixed = Fixed_1.default;
FlexLayout.Auto = Auto_1.default;
FlexLayout.HorizontalFlexLayout = HorizontalFlexLayout_1.default;
FlexLayout.VerticalFlexLayout = VerticalFlexLayout_1.default;
FlexLayout.ToolBarLayout = ToolBarLayout_1.default;
FlexLayout.BackLayout = BackLayout_1.default;
FlexLayout.ScrollLayout = ScrollLayout_1.default;
FlexLayout.useScrollLayout = ScrollLayout_1.useScrollLayout;
FlexLayout.ScrollLayoutContext = ScrollLayout_1.ScrollLayoutContext;
FlexLayout.TRBLC = TRBLC;
exports.default = FlexLayout;